import { PaginateQuery, PaginateResult } from "core/resources/types/shared";
import { useQuery } from "react-query";
import axios from "infra/http";
import { BoletosDto } from './../typings/index';

function useBoletos(data?: PaginateQuery) {
  const {
    page = 1,
    limit = 32,
    search = undefined,
  } = data ?? {
    page: 1,
    limit: 32,
    search: undefined,
  };
  return useQuery([`/mobile/v1/boletos-${page}-${limit}-${search}`], async () => {
    const res = await axios.get<PaginateResult<BoletosDto>>(`/mobile/v1/boletos`, {
      params: {
        page,
        limit,
        search,
      },
    });
    
    return res.data;
  });
}

export default useBoletos;
